<template>
  <div class="logs" >
    <el-divider content-position="left">后台操作日志</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="logs" size="medium" border style="width: 100%">
      <el-table-column v-for="(item, index) in col"
      :key="index"
      :prop="item.prop"
      :label="item.label">
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="pageSize"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logs',
  data () {
    return {

      logs: [],
      total: 0,
      currentPage: 1, // 当前页数
      pageSize: 10, // 每页显示条数
      col: [
        {
          label: 'id',
          prop: 'id'
        },
        {
          label: 'User',
          prop: 'uid'
        },
        {
          label: 'Method',
          prop: 'method'
        },
        {
          label: 'Path',
          prop: 'path'
        },
        {
          label: 'IP',
          prop: 'ip'
        },
        {
          label: 'Input',
          prop: 'input'
        },
        {
          label: '创建时间',
          prop: 'created_at'
        }
      ]
    }
  },
  computed: {
    // pageData: {
    //   get: function () {
    //     return this.logs.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
    //   }
    // }
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getLogs () {
      this.$axios.get('/api/admin/log', {
        params: {
          page: this.currentPage,
          perpage: this.pageSize
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.logs = data.data.data
            this.total = data.data.total
          }
        })
    },
    // handleSizeChange (val) {
    //   this.pageOption.pageSize = val
    // },
    // handleCurrentChange (val) {
    //   this.pageOption.currentPage = val
    // },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getLogs()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getLogs()
    }
  },
  mounted () {
    this.getLogs()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .logs
    marginLeft()
</style>



// WEBPACK FOOTER //
// src/pages/logs/Logs.vue